// extracted by mini-css-extract-plugin
export default {"newsD_d":"NewsDetails_newsD_d__6JcXS","newsd":"NewsDetails_newsd__4kcaS","newsD_l":"NewsDetails_newsD_l__Cn-Ke","title":"NewsDetails_title__JNQc4","back":"NewsDetails_back__9GqIW"};